import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'paysync.platform.config.v1';

// Read cached config synchronously so the first render already has the logo
const readCache = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

const writeCache = (cfg) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(cfg));
    } catch {
        /* ignore quota errors */
    }
};

/**
 * Returns the public platform configuration (logos, name, login image).
 * Uses localStorage as a synchronous cache to eliminate the "COBROFLOW flash"
 * on page reloads while the network request is in flight.
 */
export const usePlatformConfig = () => {
    const [config, setConfig] = useState(readCache);

    useEffect(() => {
        let cancelled = false;
        axios
            .get(`${API_URL}/api/configuracion/public`)
            .then((res) => {
                if (cancelled) return;
                setConfig(res.data);
                writeCache(res.data);
            })
            .catch((err) => {
                console.error('Error fetching platform config:', err);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return config;
};
